import React, { Component, Fragment } from 'react'
import { Overlay, Popover, Button } from 'react-bootstrap'

import File from './File'

class FileWithOverlay extends Component {
  state = { show: false, target: null }

  render() {
    const popover = (
      <Popover title="Delete File?" id="deleteFilePopover">
        {this.props.overlayText || 'Are you sure you want to delete this file?'}
        <br/>
        <br/>
        This action is <strong>irreversible</strong>.
        <br/>
        <br/>
        <center>
          <Button
            style={{display: 'inline-block', margin: '0 20px'}}
            onClick={() => this.setState({ show: false })}
          >
            Cancel
          </Button>
          <Button
            style={{display: 'inline-block', margin: '0 20px'}}
            bsStyle="danger"
            onClick={this.props.removeFile}
          >
            Delete
          </Button>
        </center>
      </Popover>
    )
    return (
      <Fragment>
        <Overlay
          rootClose
          onHide={() => this.setState({ show: false })}
          show={this.state.show}
          target={this.state.target}
          placement='right'
        >
          {popover}
        </Overlay>
        <File
          file={this.props.file}
          removeFile={(e) => this.setState({ target: e.target, show: true })}
          handleFileUpload={this.props.handleFileUpload}
        />
      </Fragment>
    )
  }
}

export default FileWithOverlay



// WEBPACK FOOTER //
// ./src/reuseable-components/file-uploading/FileWithOverlay.js